import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Typography } from "@material-ui/core";
import AppearingElement from "../Helper/AppearingElement";
import "./main.css";

// Landing Pages Section 2C
function DiamondInfoSection(props) {
    AOS.init();
    return (
        <AppearingElement variant={'custom'} className={"diamond-info-section"} threshold={0.5}>
            <div className="diamond-info-section__images-container-pendo">
                <div className="diamond-info-section__ziplyne-image-pendo">
                    <div className="diamond-info-section__ziplyne-image__text-pendo">
                        <Typography variant="h2" data-aos="fade-down" data-aos-duration="1500" data-aos-delay="1000">
                            <b>Ziplyne</b>
                        </Typography>
                    </div>
                    <img data-aos="fade-right" data-aos-duration="1500" alt="Ziplyne" width="500px" src={props.ziplyneImage} />
                </div>
                <div className="diamond-info-section__vs-text-pendo">
                    <Typography variant="h1" data-aos="fade" data-aos-duration="1500" data-aos-delay="1300">
                        vs.
                    </Typography>
                </div>
                <div className="diamond-info-section__pendo-image-pendo">
                    <div className="diamond-info-section__pendo-image__text-pendo">
                        <Typography variant="h2" data-aos="fade-down" data-aos-duration="1500" data-aos-delay="1000">
                            Pendo
                        </Typography>
                    </div>
                    <img data-aos="fade-left" data-aos-duration="1500" alt="Pendo" width="500px" src={props.pendoImage} />
                </div>
            </div>
            <div className="diamond-info-section__content-text-pendo">
                <Typography variant="h4" data-aos="fade" data-aos-duration="1500" data-aos-delay="500">
                    {props.content}
                </Typography>
            </div>
        </AppearingElement>
    );
}

export default DiamondInfoSection;